import { JsonApiModel, JsonApiModelConfig, BelongsTo, Attribute } from 'angular2-jsonapi'

import { TipoDeOcorrencia } from './tipo-de-ocorrencia.model'
import { LocalDateConverter } from '../../pkw-data/core/converters/local-date.converter'
import { Empresa } from '../../pkw-data/core/empresa.model'

@JsonApiModelConfig({
    type: 'ocorrencias'
})
export class Ocorrencia extends JsonApiModel {
    @Attribute() nome: string
    @Attribute() vencimento: Date
    @Attribute() visualizada: boolean
    @Attribute() url: string
    @Attribute() idDeReferencia: number
    @Attribute() idDeReferenciaDoDeptoOuDaCategoria: number
    @Attribute({ converter: new LocalDateConverter() })
    criacao: Date

    @BelongsTo() empresa: Empresa
    @BelongsTo() tipo: TipoDeOcorrencia
}



// WEBPACK FOOTER //
// ./src/app/pkw-data/core/ocorrencia.model.ts